import { ApiError, api } from "@/lib/api";

export type ToolGrantRole = { value: string; label: string };

export type ToolGrantUser = {
  display_label: string;
  email: string | null;
  phone: string | null;
};

export type ToolGrant = {
  id: number;
  user_id: number;
  role: string;
  product: string;
  user: ToolGrantUser;
};

export type ToolGrantCandidate = {
  user_id: number;
  display_label: string;
  email: string | null;
  phone: string | null;
  granted: boolean;
};

export type ToolGrantsPayload = {
  product: string;
  brand_id: number;
  tool_enabled: boolean;
  roles: ToolGrantRole[];
  grants: ToolGrant[];
  candidates: ToolGrantCandidate[];
};

function basePath(accountId: string | number, brandId: string | number, product: string) {
  return `/accounts/${accountId}/brands/${brandId}/tools/${product}/grants`;
}

export async function fetchToolGrants(
  accountId: string | number,
  brandId: string | number,
  product: string,
): Promise<ToolGrantsPayload> {
  return api.fetchForAccount(accountId, basePath(accountId, brandId, product));
}

export async function createToolGrant(
  accountId: string | number,
  brandId: string | number,
  product: string,
  body: { user_id: number; role?: string },
): Promise<{ grant: ToolGrant }> {
  return api.fetchForAccount(accountId, basePath(accountId, brandId, product), {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateToolGrant(
  accountId: string | number,
  brandId: string | number,
  product: string,
  grantId: number,
  body: { role: string },
): Promise<{ grant: ToolGrant }> {
  return api.fetchForAccount(accountId, `${basePath(accountId, brandId, product)}/${grantId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function deleteToolGrant(
  accountId: string | number,
  brandId: string | number,
  product: string,
  grantId: number,
): Promise<void> {
  await api.fetchForAccount(accountId, `${basePath(accountId, brandId, product)}/${grantId}`, {
    method: "DELETE",
  });
}

export { ApiError };
